import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './queryParams';

type RouteDefinition = `${typeof baseRoute}/jobPayroll/csv${`?startDate=${string}&endDate=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/jobPayroll/csv`;

export const URL = (startDate: string, endDate: string): RouteDefinition =>
	`${baseRoute}/jobPayroll/csv?startDate=${startDate}&endDate=${endDate}`;
